import { Box, Select } from 'grommet';
import { TrainingClass } from '../../../../service/common/constants';
import { FieldThumbnail } from '../../../../components/FieldThumbnail';
import React from 'react';
import deleteIcon from '../../../../assets/BoundaryTool/deleteIcon.svg';
import { useDispatch } from 'react-redux';
import { deleteTraining, editTraining } from '../../../../redux/actions/map-actions/map-action';
import { getPaddedBBox } from '../../service/common/utils';
import * as turf from '@turf/turf';

interface TrainingRegionItemProps {
  trainingClass: TrainingClass;
  focus: (center: any) => void;
}

export const TrainingRegionItem = ({ trainingClass, focus }: TrainingRegionItemProps): JSX.Element => {
  const dispatch = useDispatch();

  const options = [
    {
      label: 'Tree',
      value: 1,
    },
    {
      label: 'Barren',
      value: 2,
    },
    {
      label: 'Grass',
      value: 3,
    },
  ];

  const potential = ['', 'high', 'medium', ''];
  if (trainingClass?.geometry?.type) {
    // trainingClass.geometry.type = 'Polygon'
  }

  return (
    <Box direction={'row'} gap={'small'} align={'center'}>
      <FieldThumbnail
        feature={trainingClass}
        height={36}
        width={36}
        fieldPotential={potential[trainingClass.properties.class]}
        onClick={() => {
          const newCenter = getPaddedBBox(turf.bbox(trainingClass.geometry));
          focus(newCenter);
        }}
      />
      <Box style={{ marginLeft: '8px' }} width={'43.4%'} height={'36px'}>
        <Select
          placeholder={'Select Layer'}
          width={'100%'}
          options={options}
          onChange={(type) => {
            // setSelected(type.option)
            dispatch(editTraining(trainingClass.id, type.option.value));
          }}
          value={options[trainingClass.properties.class - 1]}
        />
      </Box>
      {/*<Box style={{ marginLeft: '16px' }} width={'42.8%'} height={'36px'}>*/}
      {/*  <TextInput*/}
      {/*    data-cy={`field-area-input-${trainingClass.id}`}*/}
      {/*    plain*/}
      {/*    focusIndicator={false}*/}
      {/*    disabled={true}*/}
      {/*    style={{ ...inputStyle, fontSize: '16px', height: '36px' }}*/}
      {/*    value={Number(trainingClass.properties![i18next.language === 'pt-BR' ? 'areaHectare' : 'area']).toFixed(2) ?? ''}*/}
      {/*  />*/}
      {/*</Box>*/}
      <img
        data-cy={`delete-training-button-${trainingClass.id}`}
        src={deleteIcon}
        alt={`Delete Icon`}
        style={{ width: '24px', height: '24px' }}
        onClick={() => {
          dispatch(deleteTraining(trainingClass.id));
        }}
      />
    </Box>
  );
};
